
function PopupBtmAgreePrivacy({ setisShowAgreePrivacy }) {

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white z-11">
      <div className="h-[52px] border-b border-[#eee] flex w-full items-center justify-center relative">
        <h2 className="font-semibold text-[16px]">개인정보처리방침</h2>
        <button className="absolute right-0 p-4" onClick={() => setisShowAgreePrivacy(false)}>
          <img src="/assets/img/close.svg" alt="close" />
        </button>
      </div>
      <div className="overflow-auto h-[calc(100%-52px)] px-5 py-7 text-[15px]">
        <h3 className="font-bold">1. 개인정보 수집 및 이용 목적</h3>
        <p>회사는 서비스 제공을 위해 아래와 같은 개인정보를 수집 및 이용합니다.</p>
        <ul className="ml-5 list-disc">
          <li>사고 접수 및 수리센터 연결 서비스 제공</li>
          <li>고객 상담 및 민원 처리</li>
        </ul>
        <br />

        <h3 className="font-bold">2. 수집하는 개인정보 항목</h3>
        <ul className="ml-5 list-disc">
          <li>필수정보: 이름, 연락처, 차량번호, 사고 정보</li>
          <li>선택정보: 서비스 이용과 관련된 추가 요청 사항</li>
        </ul>
        <br />

        <h3 className="font-bold">3. 개인정보 보유 및 이용기간</h3>
        <p>회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 다만, 관련 법령에 따라 보존할 필요가 있는 경우는 예외로 합니다.</p>
        <br />

        <h3 className="font-bold">4. 개인정보 제3자 제공</h3>
        <p>회사는 서비스 제공을 위해 아래와 같은 경우 개인정보를 제3자에게 제공합니다.</p>
        <ul className="ml-5 list-disc">
          <li>제공받는 자: 수리센터</li>
          <li>제공 목적: 사고 접수 및 수리센터 연결</li>
          <li>제공 항목: 이름, 차량번호, 사고 정보</li>
          <li>보유 및 이용기간: 서비스 제공 완료 시까지</li>
        </ul>
        <br />

        <h3 className="font-bold">5. 개인정보 처리위탁</h3>
        <p>회사는 서비스 운영을 위해 필요한 경우 개인정보 처리를 위탁할 수 있으며, 위탁 업체 및 위탁 내용은 별도로 공지합니다.</p>
        <br />

        <h3 className="font-bold">6. 개인정보 보호를 위한 기술적/관리적 조치</h3>
        <p>회사는 개인정보의 안전성을 확보하기 위해 다음과 같은 조치를 취하고 있습니다.</p>
        <ul className="ml-5 list-disc">
          <li>개인정보 암호화</li>
          <li>접근 권한 관리</li>
          <li>보안 프로그램 설치</li>
        </ul>
        <br />
        
        <h3 className="font-bold">7. 이용자의 권리</h3>
        <p>이용자는 언제든지 자신의 개인정보를 열람, 수정, 삭제할 수 있으며, 이에 대한 요청은 고객센터를 통해 가능합니다.</p>
        <br />
        
        <h3 className="font-bold">8. 개인정보보호책임자 및 문의</h3>
        <p></p>
        <ul className="ml-5 list-disc">
          <li>책임자: [담당자 이름]</li>
          <li>연락처: [연락처]</li>
          <li>이메일: [이메일 주소]</li>
        </ul>
        <br />
        
        <h3 className="font-bold">9. 동의 거부에 따른 불이익</h3>
        <p>이용자는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 다만, 동의를 거부할 경우 서비스 이용이 제한될 수 있습니다.</p>
      </div>
    </div>
  );
}

export default PopupBtmAgreePrivacy;